/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { Fragment } from 'react';
import PropTypes from "prop-types";
import { prettyDuration } from '../pretty_duration';
import { EuiFlexGroup, EuiFlexItem } from '../../../flex';
import { EuiTitle } from '../../../title';
import { EuiSpacer } from '../../../spacer';
import { EuiLink } from '../../../link';
import { EuiText } from '../../../text';
import { EuiHorizontalRule } from '../../../horizontal_rule';
export var EuiRecentlyUsed = ({
  applyTime,
  commonlyUsedRanges,
  dateFormat,
  recentlyUsedRanges = []
}) => {
  if (recentlyUsedRanges.length === 0) {
    return null;
  }

  const links = recentlyUsedRanges.map(({
    start,
    end
  }) => {
    const applyRecentlyUsed = () => {
      applyTime({
        start,
        end
      });
    };

    return <EuiFlexItem grow={false} key={`${start}-${end}`}>
        <EuiLink onClick={applyRecentlyUsed}>
          {prettyDuration(start, end, commonlyUsedRanges, dateFormat)}
        </EuiLink>
      </EuiFlexItem>;
  });
  return <Fragment>
      <EuiTitle size="xxxs">
        <span>Recently used date ranges</span>
      </EuiTitle>
      <EuiSpacer size="s" />
      <EuiText size="s" className="euiQuickSelectPopover__section">
        <EuiFlexGroup gutterSize="s" direction="column">
          {links}
        </EuiFlexGroup>
      </EuiText>
      <EuiHorizontalRule margin="s" />
    </Fragment>;
};
EuiRecentlyUsed.propTypes = {
  applyTime: PropTypes.func.isRequired,
  commonlyUsedRanges: PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired).isRequired,
  dateFormat: PropTypes.string.isRequired,
  recentlyUsedRanges: PropTypes.arrayOf(PropTypes.shape({
    end: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired,
    label: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.oneOf(["now"]), PropTypes.string.isRequired]).isRequired
  }).isRequired)
};
EuiRecentlyUsed.displayName = 'EuiRecentlyUsed';

try {
  // @ts-ignore
  EuiRecentlyUsed.displayName = "EuiRecentlyUsed"; // @ts-ignore

  EuiRecentlyUsed.__docgenInfo = {
    "description": "",
    "displayName": "EuiRecentlyUsed",
    "props": {
      "applyTime": {
        "defaultValue": null,
        "description": "",
        "name": "applyTime",
        "required": true,
        "type": {
          "name": "ApplyTime"
        }
      },
      "commonlyUsedRanges": {
        "defaultValue": null,
        "description": "",
        "name": "commonlyUsedRanges",
        "required": true,
        "type": {
          "name": "DurationRange[]"
        }
      },
      "dateFormat": {
        "defaultValue": null,
        "description": "",
        "name": "dateFormat",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "recentlyUsedRanges": {
        "defaultValue": {
          value: "[]"
        },
        "description": "",
        "name": "recentlyUsedRanges",
        "required": false,
        "type": {
          "name": "DurationRange[] | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/date_picker/super_date_picker/quick_select_popover/recently_used.tsx#EuiRecentlyUsed"] = {
      docgenInfo: EuiRecentlyUsed.__docgenInfo,
      name: "EuiRecentlyUsed",
      path: "src/components/date_picker/super_date_picker/quick_select_popover/recently_used.tsx#EuiRecentlyUsed"
    };
} catch (__react_docgen_typescript_loader_error) {}